import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ReferralCertificationModal } from "./referral-certification";

@NgModule({
  declarations: [ReferralCertificationModal],
  imports: [
    CommonComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(ReferralCertificationModal),
    FontAwesomeModule,
  ],
})
export class ReferralCertificationModule {}



// WEBPACK FOOTER //
// ./src/certification/forms/referral-certification/referral-certification.module.ts